<template>
    <VMain style="--v-layout-top: 0px;">
        <NuxtPage />
    </VMain>
</template>